function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { createKPIData } from 'helpers/kpi';
import AmbulatoryGlucoseProfile from 'modules/AmbulatoryGlucoseProfile';
import HeaderSection from './HeaderSection';
import StatisticsSection from './StatisticsSection';
import TimeInRangesSection from './TimeInRangesSection';
import styles from './PrintableAgpBgmReport.pcss';
import AgpSection from './AgpSection';
import DailyGlucoseProfilesSection from './DailyGlucoseProfilesSection';
var _React_Component;
class PrintableAgpBgmReport extends (_React_Component = React.Component) {
    render() {
        const { conversion, standards, firstName, lastName, daysWithReadings, daysWithoutReadings } = this.props;
        const { CV, readingsAverage, strictPreMealAverage, strictPostMealAverage, strictPreMealCount, strictPostMealCount, maxValue, minValue, totalReadings } = this.data;
        return /*#__PURE__*/ _jsx("div", {
            className: styles.printableAgpReport,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "page",
                children: [
                    /*#__PURE__*/ _jsx(HeaderSection, {
                        firstName: firstName,
                        lastName: lastName
                    }),
                    /*#__PURE__*/ _jsx(StatisticsSection, {
                        conversion: conversion,
                        standards: standards,
                        readingsCount: totalReadings,
                        readingsPerDay: daysWithReadings + daysWithoutReadings === 0 ? 0 : (totalReadings / (daysWithReadings + daysWithoutReadings)).toFixed(1),
                        readingsAverage: readingsAverage,
                        preMealCount: strictPreMealCount,
                        postMealCount: strictPostMealCount,
                        preMealAverage: strictPreMealAverage,
                        postMealAverage: strictPostMealAverage,
                        maxValue: maxValue,
                        minValue: minValue,
                        CV: CV
                    }),
                    /*#__PURE__*/ _jsx(TimeInRangesSection, {
                        conversion: conversion,
                        standards: standards
                    }),
                    /*#__PURE__*/ _jsx(AgpSection, {
                        conversion: conversion,
                        standards: standards,
                        readingsCount: totalReadings,
                        maxValue: maxValue
                    }),
                    /*#__PURE__*/ _jsx(DailyGlucoseProfilesSection, {
                        conversion: conversion,
                        standards: standards,
                        maxValue: maxValue
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.footer,
                        children: [
                            AmbulatoryGlucoseProfile.constants.BGM_REPORT_FOOTER,
                            /*#__PURE__*/ _jsx("img", {
                                src: "/assets/img/capturAgp.png",
                                alt: "capturAgp"
                            })
                        ]
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        const { readings, preMealReadings, postMealReadings, strictPreMealReadings, strictPostMealReadings, standards, conversion } = props;
        this.data = createKPIData({
            readings,
            strictPreMealReadings,
            strictPostMealReadings,
            preMealReadings,
            postMealReadings,
            standards,
            conversion
        });
    }
}
_define_property(PrintableAgpBgmReport, "propTypes", {
    // Explicit props
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    conversion: PropTypes.object.isRequired,
    standards: PropTypes.shape({
        maxValue: PropTypes.number.isRequired,
        preMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        }),
        postMeal: PropTypes.shape({
            highThreshold: PropTypes.number.isRequired,
            lowThreshold: PropTypes.number.isRequired
        })
    }),
    readings: PropTypes.array,
    preMealReadings: PropTypes.array,
    postMealReadings: PropTypes.array,
    strictPreMealReadings: PropTypes.array,
    strictPostMealReadings: PropTypes.array,
    daysWithReadings: PropTypes.number,
    daysWithoutReadings: PropTypes.number
});
const mapStateToProps = (state)=>({
        isDisplayedAgpProfileChart: AmbulatoryGlucoseProfile.selectors.isDisplayedAgpProfileChart(state),
        isDisplayedTimeInRanges: AmbulatoryGlucoseProfile.selectors.isDisplayedTimeInRanges(state),
        isDisplayedGlucoseStatistics: AmbulatoryGlucoseProfile.selectors.isDisplayedGlucoseStatistics(state)
    });
const ConnectedPrintableAgpBgmReport = connect(mapStateToProps)(PrintableAgpBgmReport);
export default withStyles(styles)(ConnectedPrintableAgpBgmReport);
